import { NgModule } from '@angular/core';
import {Routes, RouterModule } from '@angular/router';
import {CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule } from "@angular/forms";

import {RxFormsModule} from "@rx/forms";
import {RxViewModule} from "@rx/view";
import {    RxTableModule} from "@rx/table";

import { ProviderListComponent } from './provider-list.component'
import { PROVIDER_LIST_ROUTING } from './provider-list.routing'
import {ProvidersService } from "../providers.service";

@NgModule({
    imports: [
        PROVIDER_LIST_ROUTING ,
        CommonModule, RxViewModule, RxTableModule, RxFormsModule, FormsModule, ReactiveFormsModule,
		    ],
    declarations: [ProviderListComponent ],
    exports: [RouterModule],
    providers: [ProvidersService]
})
export class ProviderListModule { }